<template>
    <div class="carinfo-component">
        <div style="padding-bottom: 3%;" class="adway_subheaders">Step 2 / 4: Tell us about your car</div>
        <div class="input-area">
          <div class="input-field-area">
            <div class="adway_input_filed_headers">Brand</div>
            <div>
              <select class="input-filed selection__size" name="car brand" v-model="carBrand" @change="checkCarBrandOnBlur" @blur="checkCarBrandOnBlur">
                <option disabled value="">Please select one</option>
                <option v-for="car in store.state.schema.car_models" v-bind:key="car.Make">{{car.Make}}</option>
              </select>
            </div>
          </div>
          <div class="input-field-area">
            <div class="adway_input_filed_headers">Model</div>
            <div>
              <select class="input-filed selection__size" name="car models" v-model="carModel" @blur="checkCarModel">
                <option disabled value="">Please select one</option>
                <option v-for="model in carModels" v-bind:key="model">{{model}}</option>
              </select>
            </div>
            <!-- <input class="input-filed" type="text" placeholder="eg. Prius" v-model="carModel" > -->
          </div>
          <div class="input-field-area">
            <div class="adway_input_filed_headers">Year</div>
            <input class="input-filed" type="text" :oninput="rangeValue()" onkeypress="return (event.charCode !=8 && event.charCode ==0 || (event.charCode >= 48 && event.charCode <= 57))" placeholder="eg. 2020" v-model="carYear">
          </div>
          <div class="input-field-area">
              <div class="adway_input_filed_headers">Color</div>
              <div id="color-pciker">
                <div class="wrapper-dropdown">
                  <span @click="toggleDropdown" v-html="selector()">
                  </span>
                  <ul class="dropdown" v-if="colorDropdown">
                    <li v-for="color in colors" v-bind:key="color.name" @click="selectedColor(color.RGB, color.name)">
                      <span :style="{background: color.RGB}"></span>
                      {{color.name}}
                    </li>
                  </ul>
                </div>
              </div>
          </div>
        </div>
    </div>
</template>

<script>
import toast from '@utils/toast'
import store from '@store/index.js'
// import Config from './../../../../plugins/utils/Config.js'
export default {
  name: 'CarInfo',
  props: {
    driver: Object,
  },
  components: {
  },
  data: function () {
    return {
      carBrand: this.driver.carBrand,
      carModel: this.driver.carModel,
      carYear: this.driver.carYear,
      selectedColorName: this.driver.carColorName,
      selectedColorRGB: this.driver.carColorRGB,
      // config: Config,
      store: store,
      carModels: [],
      noClickColorInputField: true,
      colors: store.state.schema.colors,
      colorDropdown: false,
      currentYear: new Date().getFullYear()
    }
  },
  beforeMount(){
    if(this.carBrand != null){
      this.loadModels();
    }
  },
  watch: {
    // carBrand: function(newValue, oldValue) {

    // },
    // carModel: function(newValue, oldValue) {
    // }
  },
  methods: {
    loadModels() {
      store.state.schema.car_models.forEach(car => {
        if (car.Make === this.carBrand) {
          this.carModels = car.Models
        }
      });
      this.verifyModelByList();
    },
    verifyModelByList() {
      const inList = this.carModels.indexOf(this.carModel);
      if (inList < 0) this.carModel = '';
    },
    carModelCheck () {
      return !!this.carModel;
    },
    carBrandCheck () {
      return !!this.carBrand;
    },
    rangeValue () {
      if (this.carYear > this.currentYear) {
        this.carYear = this.currentYear
      }
    },
    preload() {
      this.carBrand = this.driver.carBrand;
      this.carModel = this.driver.carModel;
      this.carYear = this.driver.carYear;
      this.selectedColorName = this.driver.carColorName;
      this.selectedColorRGB = this.driver.carColorRGB;
    },
    changeSomeDriverSettings () {
      const errors = [];
      if (!this.carModelCheck()) errors.push(`Car model is not selected`);
      if (!this.carBrandCheck()) errors.push(`Car brand is not selected`);
      if (errors.length) {
        toast.errorMessage(errors.join("<br>"));
      } else {
        this.driver.carBrand = this.carBrand
        this.driver.carModel = this.carModel
        this.driver.carYear = this.carYear
        this.driver.carColorName = this.selectedColorName
        this.driver.carColorRGB = this.selectedColorRGB
        this.$emit('changeDriver', this.driver);
      }
    },
    checkCarBrandOnBlur(){
      if(this.carBrandCheck()) {
            this.carBrand = store.state.schema.car_models[0].Make
          }
        store.state.schema.car_models.forEach(car => {
          if (car.Make === this.carBrand) {
            this.carModels = car.Models
            if(this.carModel !=='') this.carModel = ''
          }
        })
    },

    checkCarModel(){
      if(!this.carBrandCheck()){
        if(this.carModelCheck()) {
          this.carModel = this.carModels[0]
        }
      }

    },
    selector () {
      if (!this.selectedColorName) {
        return 'Color'
      } else {
        return `<span style="background: ${this.selectedColorRGB}"></span> ${this.selectedColorName}`
      }
    },
    selectedColor (colorRGB, colorName) {
      this.selectedColorRGB = colorRGB
      this.selectedColorName = colorName
      this.toggleDropdown()
    },
    toggleDropdown () {
      this.colorDropdown = !this.colorDropdown
    }
  },
  created: function () {
  }
}
</script>

<style>

.wrapper-dropdown {
    position: relative;
    width: 241px;
    background: #FFF;
    color: #2e2e2e;
    outline: none;
    cursor: pointer;
}

.wrapper-dropdown > span {
	width: 100%;
	display: block;
	border: 1px solid #ababab;
	padding: 5px;
}
.wrapper-dropdown > span > span {
  padding: 0 12px;
  margin-right: 5px;
}
.wrapper-dropdown > span:after {
    content: "";
    width: 0;
    height: 0;
    position: absolute;
    right: 16px;
    top: calc(50% + 4px);
    margin-top: -6px;
	  border-width: 6px 6px 0 6px;
    border-style: solid;
	  border-color: #2e2e2e transparent;
}

.wrapper-dropdown .dropdown {
    position: absolute;
	  z-index: 10;
    top: 100%;
    left: 0;
    right: 0;
    background: #fff;
    font-weight: normal;
	  list-style-type: none;
	  padding-left: 0;
	  margin: 0;
	  border: 1px solid #ababab;
	  border-top: 0;
}

.wrapper-dropdown .dropdown li {
    display: block;
    text-decoration: none;
    color: #2e2e2e;
	  padding: 5px;
	  cursor: pointer;
}

.wrapper-dropdown .dropdown li > span {
  padding: 0 12px;
  margin-right: 5px;
}

.wrapper-dropdown .dropdown li:hover {
    background: #eee;
	  cursor: pointer;
}

.selection__size{
  width: 254px;
}

@media only screen and (max-width: 600px) {
  .selection__size{
    width: 100% !important;
  }

  .wrapper-dropdown{
    width: 96%;
  }
}

</style>
